import { render } from "./footerES.vue?vue&type=template&id=0e35f530&scoped=true"
import script from "./footerES.vue?vue&type=script&lang=js"
export * from "./footerES.vue?vue&type=script&lang=js"

import "./footerES.vue?vue&type=style&index=0&id=0e35f530&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e35f530"]])

export default __exports__